export enum SymbolTypeEnum {
    Unknown="",
    Forex="forex",
    Crypto="crypto",
    Equity="equity",
    Commodity="commodity",
    Index="index",
    Bonds="bonds"
}

